// extracted by mini-css-extract-plugin
module.exports = {"radio":"_02712f2b3b--radio--xGbrA","indicator":"_02712f2b3b--indicator--UVUda","label":"_02712f2b3b--label--ZoQ_y"};